/**
 * Strip the file extension from a name. The Library Name defaults to
 * this — users care about "Q3 Budget", not "Q3 Budget.xlsx".
 */
export const stripExtension = (filename: string): string => {
	if (!filename) return ''
	const lastDot = filename.lastIndexOf('.')
	if (lastDot <= 0 || lastDot === filename.length - 1) return filename
	return filename.slice(0, lastDot)
}

/** Trim + lowercase. Used for case-insensitive name matching. */
export const trimAndLowercase = (s: string | null | undefined): string =>
	(s ?? '').trim().toLowerCase()
